import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getParameterByName } from '../../../../helpers/location';
import DlPictureWidget from '../Widgets/DlPictureWidget'

const DlPictureDashboard = props => (
    <div id="dl-picture-dashboard">
        <header className="content-header">
            <h1>
                Download picture
                <small>dashboard</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-wrench"/> Tools</li>
                <li className="text-bold"><Link to="/dlpicture">Team picture</Link></li>
            </ol>
        </header>
        <section className="content">
            <DlPictureWidget championship={parseInt(getParameterByName('championship', props.location.search), 10)}/>
        </section>
    </div>
);

export default connect(
    () => ({}),
    dispatch => ({ dispatch }),
)(DlPictureDashboard);



// WEBPACK FOOTER //
// ./src/pages/Tools/DlPicture/Dashboard/DlPictureDashboard.js